import { render, staticRenderFns } from "./LandingPageHome.vue?vue&type=template&id=50f7c6f8&scoped=true&"
import script from "./LandingPageHome.vue?vue&type=script&lang=js&"
export * from "./LandingPageHome.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageHome.vue?vue&type=style&index=0&id=50f7c6f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f7c6f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
